/**
 * Pijlen bij de carrousel van sections/moevs-product-row (Figma d-collectie, "Vorige" en "Volgende").
 * Werkt naast <moevs-scrollrow> (assets/moevs-scrollrow.js, streepjes). Een klik schuift een kaart op;
 * aan het begin of eind staat de knop uit. Opnieuw gekoppeld na shopify:section:load in de themabewerker.
 */
const ROW = '.mv-pr__list.mv-scrollrow';

function bind(root) {
  root.querySelectorAll('.mv-pr--desktop-carousel').forEach((section) => {
    const row = section.querySelector(ROW);
    const prev = section.querySelector('[data-mv-row-prev]');
    const next = section.querySelector('[data-mv-row-next]');
    if (!row || !prev || !next || row.dataset.mvNav) return;
    row.dataset.mvNav = '1';

    const step = () => {
      const first = row.children[0];
      if (!first) return row.clientWidth;
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 2;
      const left = Math.abs(row.scrollLeft);
      prev.disabled = left <= 2;
      next.disabled = left >= max;
    };

    const go = (dir) => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rtl = getComputedStyle(row).direction === 'rtl' ? -1 : 1;
      row.scrollBy({ left: dir * rtl * step(), behavior: reduce ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    row.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(row);
    update();
  });
}

bind(document);

document.addEventListener('shopify:section:load', (event) => bind(event.target));
